(function () {
  'use strict';

  var B2B = window.ADDA_B2B || { isLoggedIn: false, isSalon: false, variantData: {} };
  var IS_COMPANY = !!B2B.isSalon;
  var VARIANT_DATA = B2B.variantData || {};

  var ALLOWED = IS_COMPANY
    ? ['salon', 'both']
    : ['retail', 'both', ''];

  function normalizeType(value) {
    if (value === undefined || value === null) return '';
    return String(value).trim().toLowerCase();
  }

  function isVariantAllowed(variantId) {
    var ct = normalizeType(VARIANT_DATA[String(variantId)]);

    if (!ct) {
      return !IS_COMPANY;
    }

    return ALLOWED.indexOf(ct) !== -1;
  }

  function getVariantIdFromElement(el) {
    if (!el) return null;

    if (el.dataset && el.dataset.variantId) return el.dataset.variantId;
    if (el.getAttribute && el.getAttribute('data-variant-id')) return el.getAttribute('data-variant-id');
    if (el.value && /^\d+$/.test(String(el.value))) return el.value;

    var input = el.querySelector && el.querySelector('input[name="id"], input[type="radio"][name="id"], [data-variant-id]');
    if (input) {
      if (input.dataset && input.dataset.variantId) return input.dataset.variantId;
      if (input.value && /^\d+$/.test(String(input.value))) return input.value;
    }

    return null;
  }

  function getFirstAllowedOption(select) {
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      if (!opt.value) continue;
      if (isVariantAllowed(opt.value)) return opt;
    }
    return null;
  }

  function getFirstAllowedVariantId() {
    for (var id in VARIANT_DATA) {
      if (Object.prototype.hasOwnProperty.call(VARIANT_DATA, id)) {
        if (isVariantAllowed(id)) return id;
      }
    }
    return null;
  }

  function hideElement(el, hidden) {
    if (!el) return;
    el.style.display = hidden ? 'none' : '';
  }

  function updateAddToCartButtons(variantId) {
    var allowed = isVariantAllowed(variantId);
    document.querySelectorAll('[name="add"], .btn-add-to-cart, .product-form__submit').forEach(function (btn) {
      btn.disabled = !allowed;
      if (!allowed) btn.setAttribute('data-b2b-blocked', '1');
      else btn.removeAttribute('data-b2b-blocked');
    });
  }

  function filterSelects(container) {
    container.querySelectorAll('select[name="id"]').forEach(function (sel) {
      Array.from(sel.options).forEach(function (opt) {
        if (!opt.value) return;
        var allowed = isVariantAllowed(opt.value);
        opt.hidden = !allowed;
        opt.disabled = !allowed;
      });

      var selected = sel.options[sel.selectedIndex];
      if (!selected || selected.hidden || selected.disabled) {
        var fallback = getFirstAllowedOption(sel);

        if (fallback) {
          sel.value = fallback.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          updateAddToCartButtons(fallback.value);
        }
      }
    });
  }

  function filterRadios(container) {
    container.querySelectorAll('input[type="radio"][name="id"]').forEach(function (input) {
      var vid = input.value;
      if (!vid) return;

      var allowed = isVariantAllowed(vid);
      var wrapper =
        input.closest('label') ||
        input.closest('.variant-button') ||
        input.closest('.swatch') ||
        input.closest('.product-form__input') ||
        input.parentElement;

      input.disabled = !allowed;
      if (!allowed) input.checked = false;
      hideElement(wrapper, !allowed);
    });

    var checked = container.querySelector('input[type="radio"][name="id"]:checked:not([disabled])');
    if (!checked) {
      var fallback = container.querySelector('input[type="radio"][name="id"]:not([disabled])');
      if (fallback) {
        fallback.checked = true;
        fallback.dispatchEvent(new Event('change', { bubbles: true }));
        updateAddToCartButtons(fallback.value);
      }
    }
  }

  function filterDataVariantElements(container) {
    container.querySelectorAll('[data-variant-id]').forEach(function (el) {
      var vid = el.getAttribute('data-variant-id');
      if (!vid) return;

      var allowed = isVariantAllowed(vid);
      var wrapper =
        el.closest('label') ||
        el.closest('button') ||
        el.closest('.variant-button') ||
        el.closest('.swatch') ||
        el.closest('.product-form__input') ||
        el;

      hideElement(wrapper, !allowed);

      if ('disabled' in el) {
        el.disabled = !allowed;
      }
    });
  }

  function filterGenericVariantButtons(container) {
    container.querySelectorAll('label, button, .variant-button, .swatch, .product-form__input').forEach(function (el) {
      var vid = getVariantIdFromElement(el);
      if (!vid) return;

      var allowed = isVariantAllowed(vid);
      hideElement(el, !allowed);

      var input = el.querySelector('input');
      if (input) {
        input.disabled = !allowed;
        if (!allowed) input.checked = false;
      }
    });
  }

  function filterContainer(container) {
    if (!container) return;
    filterSelects(container);
    filterRadios(container);
    filterDataVariantElements(container);
    filterGenericVariantButtons(container);
  }

  function syncInitialProductVariant() {
    var forms = document.querySelectorAll('product-form, form[action="/cart/add"], .product-form, .shopify-product-form');

    forms.forEach(function(form) {
      var select = form.querySelector('select[name="id"]');
      if (select) {
        var currentId = select.value;
        if (!isVariantAllowed(currentId)) {
          var fallback = getFirstAllowedOption(select);
          if (fallback) {
            select.value = fallback.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            updateAddToCartButtons(fallback.value);
          }
        }
      }

      var checkedRadio = form.querySelector('input[type="radio"][name="id"]:checked');
      if (checkedRadio && !isVariantAllowed(checkedRadio.value)) {
        var fallbackRadio = form.querySelector('input[type="radio"][name="id"]:not([disabled])');
        if (fallbackRadio) {
          fallbackRadio.checked = true;
          fallbackRadio.dispatchEvent(new Event('change', { bubbles: true }));
          updateAddToCartButtons(fallbackRadio.value);
        }
      }

      var hiddenIdInput = form.querySelector('input[type="hidden"][name="id"]');
      if (hiddenIdInput && !isVariantAllowed(hiddenIdInput.value)) {
        var fallbackId = getFirstAllowedVariantId();
        if (fallbackId) {
          hiddenIdInput.value = fallbackId;
          hiddenIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          updateAddToCartButtons(fallbackId);
        }
      }
    });
  }

  function initProductPage() {
    document.querySelectorAll('product-form, form[action="/cart/add"], .product-form, .shopify-product-form').forEach(function (form) {
      filterContainer(form);
    });

    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      updateAddToCartButtons(e.detail.variant.id);
      filterContainer(document);
    });

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target) return;

      if (
        target.matches('select[name="id"]') ||
        target.matches('input[type="radio"][name="id"]') ||
        target.matches('[data-variant-id]')
      ) {
        var vid = getVariantIdFromElement(target);
        if (vid) updateAddToCartButtons(vid);
      }
    });
  }

  function initCards() {
    document.querySelectorAll('product-card, .product-card, [class*="product-grid__item"], [data-quick-add]').forEach(function (card) {
      filterContainer(card);
    });
  }

  function initCartGuard() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.getAttribute('action') !== '/cart/add') return;

      var idInput = form.querySelector('input[name="id"], select[name="id"]');
      if (!idInput) return;

      var variantId = idInput.value;
      if (!isVariantAllowed(variantId)) {
        e.preventDefault();
        console.warn('[ADDA B2B] Blocked add-to-cart for variant:', variantId);
      }
    }, true);
  }

  function watchDOM() {
    var mo = new MutationObserver(function () {
      filterContainer(document);
      syncInitialProductVariant();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    console.log('[ADDA B2B] Init', B2B);
    filterContainer(document);
    initProductPage();
    initCards();
    initCartGuard();
    syncInitialProductVariant();
    watchDOM();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();